var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0833 5H9.20833C8.35743 5 7.54138 5.34241 6.9397 5.9519C6.33802 6.5614 6 7.38805 6 8.25C6 9.11195 6.33802 9.9386 6.9397 10.5481C7.54138 11.1576 8.35743 11.5 9.20833 11.5H13.7917C14.6426 11.5 15.4586 11.8424 16.0603 12.4519C16.662 13.0614 17 13.888 17 14.75C17 15.612 16.662 16.4386 16.0603 17.0481C15.4586 17.6576 14.6426 18 13.7917 18H6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.b552177310da92e9c315c86b7c5b3d37.svg";
export { ForwardRef as ReactComponent };